import {Component} from '@angular/core';
import {ChangeDetectorRef, OnInit, OnDestroy} from '@angular/core';
import {UrlConstants} from './constants/url-constants';
import {Constants} from './constants/ebtq-constants';
import {ApiService} from './services/api.service';
import {UserDetailsModel} from './constants/userModel';
import {environment} from '../environments/environment';
import {IdleService} from './services/idle.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthguardServiceService} from './services/authguard-service.service';
import {Title} from '@angular/platform-browser';

// @ts-ignore
import moment from 'moment-business-days';
import 'moment-timezone';
import {ConfirmationService} from '@fm-ui-adk/components-3/common/services';


@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  userDetails!: UserDetailsModel;
  checkLogin = false;
  userName: any;
  customerAPIGEEInfoSub: any;
  public countdown!: number;
  header = true;
  title = 'eBoutique Main Menu';
  // logo = require('../assets/images/fannie_mae_logo.png').default;
  // headerdivider = require('../assets/images/EMBHeaderDividr.gif').default;
  //menudivider = require('../assets/images/EMBMenuDividr.gif').default;
  // image = require('../assets/images/FannieMae.svg').default;
  items!: MenuItem[];

  isAdmin = false;
  isDeveloper = false;
  rmIntView = false;
  rmIntUpdate = false;
  rmExtSerView = false;
  rmExtDelView = false;
  rmExtDelUpdate = false;
  rmExtSerpdate = false;
  rmIndicator!: string;
  systemIndicator!: string;
  servicingIndicator!: string;
  deliveryIndicator!: string;
  externalFlag!: boolean;
  gridLayoutBody = 'col-12';

  revokeAccessTm = {};

  levelOneMenu = [
    {
      title: 'Help',
      url: '/help',
      list: [],
      exactMatch: true,
      target: '_blank'
    },
    {
      title: 'Legal',
      href: 'https://www.fanniemae.com/about-us/legal-disclosure',
      list: [],
      exactMatch: true,
      target: '_blank'
    },
    {
      title: 'Contact Us',
      href: 'https://www.fanniemae.com/about-us/contact-us',
      list: [],
      exactMatch: true,
      target: '_blank',
    }

  ];


  externalErrorMenu = [

    {
      title: 'Legal',
      href: 'https://www.fanniemae.com/about-us/legal-disclosure',
      list: [],
      exactMatch: true,
      target: '_blank'
    },
    {
      title: 'Contact Us',
      href: 'https://www.fanniemae.com/about-us/contact-us',
      list: [],
      exactMatch: true,
      target: '_blank',
    }

  ];

  userId = '';
  interval: ReturnType<typeof setInterval> | undefined;

  constructor(private service: ApiService, private authService: AuthguardServiceService,
              private idle: IdleService, private logoutConfirmationService: ConfirmationService,
              private router: Router, private route: ActivatedRoute, private titleService: Title,
              private cdr: ChangeDetectorRef) {
    this.userName = {firstName: '', lastName: ''};
  }

  ngOnInit() {

    this.validateLBD();

    this.titleService.setTitle(this.title);

    // checking auth flag
    this.authService.authFlagObservable$.subscribe(() => {
      this.userId = sessionStorage.getItem('userID') ?? '';
      // Without this, Angular 22's CD scheduling can leave the *ngIf gating the whole app (including router-outlet) never re-evaluated, causing a permanent blank page
      this.cdr.detectChanges();
    }, error => {
      console.error(error);
    });

    this.customerAPIGEEInfoSub = this.authService.customerApigeeInfoSub
      .subscribe(() => {
        this.setAPIGEEUserName();
        this.cdr.detectChanges();
      });
    // Refresh the same page if onClick on side menu also add onSameUrlNavigation : 'reload' in routing module
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.items = [
      {
        label: 'Logout',
        icon: 'fmi fmi-sign-out',
        command: () => {
          this.logout();
        }
      }
    ];
    const host = document.location.hostname;

    if (host.toString() === 'localhost') {
      // hardcode in local for user details
      setTimeout(() => {
        this.userDetails = Constants.USER_DETAILS;
        this.userName = {
          firstName: this.userDetails.firstName,
          lastName: this.userDetails.lastName
        };
        this.service.userDetails.next(this.userDetails as any);
      }, 1000);
      this.checkLogin = true;
    }


    this.configureIdle();
    this.idle.watch();

  }
  checkSameDay(date1: any, date2: any) {
    return moment(date1).isSame(date2, 'day');
  }

  validateLBD() {
    const businessDays: any = moment(new Date(), 'DD MM YYYY hh').monthBusinessDays();
    const mnthlastBusinessDay = businessDays[businessDays.length - 1]._d;


    if (this.checkSameDay(moment(new Date()), moment(mnthlastBusinessDay))) {
      const currentDate = new Date(new Date().toLocaleString('en-US', {timeZone:'est'}));
      const currentDtTwoPM = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 14, 0, 0, 0);
      if (!moment(currentDate).isAfter(currentDtTwoPM)) {
        this.RevokeAccessTime();
      }
    }
  }
  RevokeAccessTime() {
    this.interval = setInterval( () => {
      const currentDate = new Date(new Date().toLocaleString('en-US', {timeZone:'est'}));
      const currentDtTwoPM = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 14, 0, 0, 0);
      this.revokeAccessTm = {
        ct : currentDate.getTime(),
        lbd : currentDtTwoPM.getTime(),
        df: currentDtTwoPM.getTime() - currentDate.getTime()
      };
      if ( (currentDtTwoPM.getTime() - currentDate.getTime()) === 0 ) {
        this.getRevisedSystemAttr();
        clearInterval(this.interval);
      };
    }, 1000);
  }
  getRevisedSystemAttr() {
    this.service.getValueCache().subscribe(
      (data) => {

        const keyMap = data.sysAttrMap;
        this.servicingIndicator = keyMap[Constants.RM_ServicingSysAvailable];
        window.location.reload();
      }
    );
  }

  /**
   * Check if the router url contains the specified route
   *
   * @param {string} route
   * @returns
   * @memberof MyComponent
   */
  hasRoute(route: string) {
    if (this.router.url.includes(route)) {
      this.gridLayoutBody = 'col-12';
      return true;
    } else {
      this.gridLayoutBody = 'col-9';
      return false;
    }

  }


  /* Method is used to collapse reverse mortgage and developer menu when clicked on admin */
  public adminNav()
  {
    this.collapseDeveloper();
    this.collapseRevMortgage();
  }

  /* Method is used to collapse admin and developer menu when clicked on reverse mortgage */
  public reverseMortgageNav()
  {
    this.collapseDeveloper();
    this.collapseAdmin();
  }

  /* Method is used to collapse reverse mortgage and admin menu when clicked on developer */
  public developerNav()
  {
    this.collapseRevMortgage();
    this.collapseAdmin();
  }

  /* Method is used when all menus need to be collapsed */
  public mainMenuNav()
  {
    this.titleService.setTitle(this.title);
    this.collapseAdmin();
    this.collapseDeveloper();
    this.collapseRevMortgage();
  }

  /* Menu Collapse Helper Functions */
  public collapseAdmin()
  {
    const el3 = document.getElementById('submenu3');
    if (el3 != null)
    {
      el3.classList.remove('show');
      document.querySelector('[data-bs-target="#submenu3"]')?.classList.add('collapsed');
    }
  }

  public collapseRevMortgage()
  {
    const el1 = document.getElementById('submenu1');
    if (el1 != null)
    {
      el1.classList.remove('show');
      document.querySelector('[data-bs-target="#submenu1"]')?.classList.add('collapsed');
    }
  }

  public collapseDeveloper()
  {
    const el5 = document.getElementById('submenu5');
    if (el5 != null)
    {
      el5.classList.remove('show');
      document.querySelector('[data-bs-target="#submenu5"]')?.classList.add('collapsed');
    }
  }

  public setAPIGEEUserName() {
    if (this.userName.firstName.length <= 0) {
      this.userName = {
        firstName: this.authService.getAPIGEECustomerData().firstName,
        lastName: this.authService.getAPIGEECustomerData().lastName,
      };
    }
    /** get the session roles and show or hide from user **/
    this.isAdmin = JSON.parse(sessionStorage.getItem('isAdmin') ?? 'false');
    this.isDeveloper = JSON.parse(sessionStorage.getItem('isDeveloper') ?? 'false');
    this.rmIntView = JSON.parse(sessionStorage.getItem('isRMInternal_View') ?? 'false');
    this.rmIntUpdate = JSON.parse(sessionStorage.getItem('isRMInternal_Update') ?? 'false');
    this.rmExtSerView = JSON.parse(sessionStorage.getItem('isRMExternal_Servicing_View') ?? 'false');
    this.rmExtSerpdate = JSON.parse(sessionStorage.getItem('isRMExternal_Servicing_Update') ?? 'false');
    this.rmExtDelView = JSON.parse(sessionStorage.getItem('isRMExternal_Delivery_View') ?? 'false');
    this.rmExtDelUpdate = JSON.parse(sessionStorage.getItem('isRMExternal_Delivery_Update') ?? 'false');

    //adding developer indicators
    this.rmIndicator = sessionStorage.getItem('RMSystemIndicator') ?? '';
    this.systemIndicator = sessionStorage.getItem('SystemIndicator') ?? '';
    this.servicingIndicator = sessionStorage.getItem('ServicingSystemIndicator') ?? '';
    this.deliveryIndicator = sessionStorage.getItem('DeliverySystemIndicator') ?? '';
  }

  ngOnDestroy() {
  }


  logout() {
    this.userId = '';
    window.location.href = UrlConstants.getLogoutUrl();
    sessionStorage.setItem('isAuthendicated', 'false');
  }


  // Configure the idle detection and subscribe to idle events
  private configureIdle(): void {
    // Read config, with defaults
    const warningTimeoutInMins = Number(environment.warningTimeoutInMins) || 26;
    const logoutTimeoutInMins = (Number(environment.logoutTimeoutInMins) || (warningTimeoutInMins + 2)) -
      warningTimeoutInMins;

    // Configure the Idle timeouts
    this.idle.setIdle(warningTimeoutInMins * 60);
    this.idle.setTimeout(logoutTimeoutInMins * 60);
    this.countdown = warningTimeoutInMins * 60;

    // sets the interrupts, in this case, things like clicks, scrolls, touches to the document (no mousemove)
    this.idle.setInterrupts(['keydown', 'wheel', 'mousedown', 'touchstart', 'touchmove', 'scroll']);

    // Subscribe and respond to idle events
    this.idle.onIdleStart.subscribe(() => {
      this.showDialog();
    });

    this.idle.onIdleEnd.subscribe(() => {
      this.onIdleEnd();
    });

    this.idle.onTimeoutWarning.subscribe((countdown: number) => {
      this.countdown = countdown;
    });

    this.idle.onTimeout.subscribe(() => {
      this.clearCacheAndLogOut();
    });
  }

  showDialog() {
    this.logoutConfirmationService.confirm({
      message: `This Session is about to timeout in  <strong>${this.countdown}</strong> seconds.
      Would you like to continue?.`,
      header: 'Session Timeout',
      accept: () => {
        //Actual logic to perform a confirmation
        this.restartSession();
      },
      reject: () => {
        this.clearCacheAndLogOut();
      },
      key: 'confirm'
    });
  }

  private onIdleEnd(): void {
    // this.idleModal.isOpened = false;
    // this.idleModal.close();
    // restart will be called here too. Do not remove.
    this.restartSession();
  }

  public restartSession() {
    // Restart the Idle detection
    this.idle.stop();
    this.idle.watch();
    //Call a backend service to have the CDX session active for another 30 minutes
    this.service.healthCheck().subscribe(
      () => {
        // do nothing
      },
      () => {
        // do nothing
      });
  }

  public clearCacheAndLogOut(): void {
    this.clearCache();
    // Browse to logout url
    this.logout();
  }

  private clearCache(): void {
    // Keep it clean
    localStorage.clear();
  }

  helpMethod()
  {
  }
}

// interface for profileMenu
export interface MenuItem {
  label?: string;
  icon?: string;
  command?: (event?: any) => void;
  url?: string;
  href?: string;
  target?: string;
  iconPosition?: string;
}
